import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["responsive", "size", "versions", "className", "sizes"];
import React from "react";
import { Dummy } from "../Image";
import { jsx as _jsx } from "react/jsx-runtime";
var typeCheckerSizeResp = function typeCheckerSizeResp(props) {
  return props.responsive === undefined && props.size === undefined && new Error("Prop size or responsive necessary, both were undefined");
};

/**
 * renders a responsive image.
 * you can either let the component display a version based on the srcset
 * or you can explicitly define a size.
 *
 * this component extends the basic img, so all other props will be passed down
 *
 * @param { import("./index").AssetImageProps } param0
 */
export var AssetImage = function AssetImage(_ref) {
  var responsive = _ref.responsive,
    size = _ref.size,
    versions = _ref.versions,
    className = _ref.className,
    sizes = _ref.sizes,
    props = _objectWithoutProperties(_ref, _excluded);
  var w320 = versions.w320,
    w460 = versions.w460,
    w640 = versions.w640,
    w970 = versions.w970,
    full = versions.full;
  if (process.env.NODE_ENV === "development" && responsive === undefined && size === undefined) {
    throw new Error("either resonsive or size must be specified");
  }
  className = "".concat(className ? "".concat(className, " ") : "", "img-responsive");
  if (responsive) {
    return /*#__PURE__*/_jsx(Dummy, _objectSpread(_objectSpread({}, props), {}, {
      className: className,
      sizes: sizes,
      src: w320,
      srcSet: "".concat(w320, " 320w, ").concat(w460, " 460w, ").concat(w640, " 640w, ").concat(w970, " 970w, ").concat(full, " 1280w")
    }));
  } else {
    return /*#__PURE__*/_jsx(Dummy, _objectSpread(_objectSpread({}, props), {}, {
      className: className,
      src: versions[size]
    }));
  }
};
AssetImage.propTypes = {
  responsive: typeCheckerSizeResp
};
export default AssetImage;
//# sourceMappingURL=Image.js.map